import type { ReactNode } from "react";
import { Fragment } from "react";
import { NavLink, useParams } from "react-router-dom";

import Layout from "../layout";

export default function (props: Parameters<typeof Layout>["0"]): ReactNode {
  const { accountId, deploymentId } = useParams();

  return (
    <Layout
      {...props}
      secondaryNavElements={
        <Fragment>
          {deploymentId && (
            <section>
              <NavLink end to={`/admin/account/${accountId}/deployment/${deploymentId}`}>
                Deployment {deploymentId}:
              </NavLink>
              <NavLink to={`/admin/account/${accountId}/deployment/${deploymentId}/credential`}>Credentials</NavLink>
              <NavLink to={`/admin/account/${accountId}/deployment/${deploymentId}/entitlement`}>Entitlements</NavLink>
              <NavLink to={`/admin/account/${accountId}/deployment/${deploymentId}/usage`}>Usage</NavLink>
            </section>
          )}
          {props.secondaryNavElements}
        </Fragment>
      }
    />
  );
}
